<template>
  <van-loading size="24px" text-color="#0094ff" color="#0094ff" vertical
    >登录中...</van-loading
  >
  <!-- <div>
    <div class="btnlist">
      <img
        src="@/image/index.png"
        alt=""
        srcset=""
        style="width: 200px; height: 200px"
        class="img"
      />
      <van-button class="goPrize" @click="login">登录</van-button>
    </div>
  </div> -->
</template>

<script>
import { getUrlParams } from "@/utils/getUrlParams.js";
// import { Toast } from 'vant';
export default {
  //TODO:登录逻辑，后期在此处调用登录后将用户信息存入仓库
  async created() {
    const urlCode = getUrlParams(window.location.href)?.code;
    const urlPhone =
      getUrlParams(window.location.href)?.state?.split("#")[0] || "";
    //手机号校验
    if (/^1[23456789]\d{9}$/.test(urlPhone)) {
      localStorage.setItem("phone", urlPhone);
    } else {
      console.log("手机号格式错误==============");
    }
    if (urlCode) {
      localStorage.setItem("code", urlCode);
      setTimeout(() => {
        this.$router.go(-1);
        // window.history.back()
        // this.$router.replace({name:"Prize"}) //存在一个多出的页面 windows.close()还没试
      }, 800);
    } else {
      this.$router.replace({
        name: "Customer",
      });
    }
  },
  methods: {},
};
</script>

<style scoped>
.img {
  display: block;
  margin: 50px auto;
}

.btnlist {
  position: absolute;
  bottom: 30%;
  left: 0;
  right: 0;
  opacity: 0.8;
  margin: 10px auto;
  width: 80%;
}

.goPrize {
  margin: 2% 0;
  width: 100%;
  /* height: calc(100vh / 17); */
  box-shadow: 0 5px 10px -5px rgb(0, 0, 0);
  color: #fff !important;
  letter-spacing: 3px;
  border-radius: 30px;
}

.van-button--default {
  background-image: linear-gradient(to bottom right, #f7804d, #f14532);
  font-size: 18px;
  font-weight: 600;
  border: none;
}
</style>
